Wee.fn.make('landingPage', {
	init: function() {
		var priv = this.$private;

		$('ref:slider').each(function(slider) {
			Wee.fn.easySlide({
				el: slider
			});
		});

		priv.scrollToSection();
	},

	unload: function() {
		Wee.events.off(false, 'landingPage');
	}
}, {
	/**
	 * Scroll to section on page when logo is clicked
	 *
	 * @private
	 */
	scrollToSection: function() {
		$('ref:sectionLink').on('click.landingPage', function(e, el) {
			var $link = $(el),
				sectionId = $link.attr('data-id');

			$('ref:landingPageContent').each(function(content) {
				var $content = $(content);

				if ($content.attr('id') === sectionId) {
					$.animate.tween($._body, {
						scrollTop: ($content.offset().top - $('ref:header').height())
					});
				}
			});

			e.preventDefault();
		});
	}
});